import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class VideoManagerService {
  private readonly currentPlayingVideoId$ = new BehaviorSubject<string | null>(null);

  setCurrentPlayingVideo(videoId: string): void {
    this.currentPlayingVideoId$.next(videoId);
  }

  stopCurrentVideo(): void {
    this.currentPlayingVideoId$.next(null);
  }

  getCurrentPlayingVideoId(): string | null {
    return this.currentPlayingVideoId$.value;
  }

  isVideoPlaying(videoId: string): boolean {
    return this.currentPlayingVideoId$.value === videoId;
  }
}
